import React, { useState, useEffect, useMemo } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Button,
} from '@digital/ui';
import FiltrosRelatorioCiclorOrcamentario from './FiltrosRelatorioCicloOrcamentario';
import { Collapse, Input, Tooltip, Icon } from 'antd';
import { CicloOrcamentarioRelatorio, Filtros, postGetAllRelatorioCicloOrcamentario, relatorioExportExcel } from '@app/api/crf/crfRelatorioCicloOrcamentario';
import RelatorioCicloOrcamentarioTabela from './relatorioCicloOrcamentarioTabela';


const CrfRelatorioCicloOrcamentario = () => {
  const { Panel } = Collapse;

  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();
  const [filtro, setFiltro] = useState<Filtros>();


  const handleFilter = (filtros: Filtros) => {
    setFiltro(filtros);
    postGetAllRelatorioCicloOrcamentario(filtros).then((data) => {
      setCicloOrcamentarioRelatorioTotal(data);
    });
    return true;
  }


  const btnAcoes = () => {
    if (filtro) {
      return [
        <Button
          type="primary"
          size={'small'}
          icon="files-ms_excel"
          onClick={() => {
            relatorioExportExcel(filtro);
          }}>
          Exporta Relatório
        </Button>
      ]
    }
    return [];
  }

  return (
    <SimpleView >
      <GridView noform>
        <FiltrosRelatorioCiclorOrcamentario
          onSearch={handleFilter}
          atualizarTela={() => { }} />
        {(cicloOrcamentarioRelatorioTotal) ? (
          <Widget
            title="RESULTADO"
            span={12}
            actions={btnAcoes()}>
            <RelatorioCicloOrcamentarioTabela
              cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
              filtro={filtro ? filtro : {} as Filtros}
              mostrarColunaDetalhe={true}
              quantidadeItemPaginacao={25}
            />
          </Widget>
        ) : (<> </>)}
      </GridView>
    </SimpleView>
  );
};

export default CrfRelatorioCicloOrcamentario;
